import React from 'react';
import PropTypes from 'prop-types';
import { useHasFeatureFlag } from '~/modules/common/hooks';
import { DEFAULT_RATE } from '../hooks/enum';
import RateListDataTable from './RateListDataTable';
import { useListColumns, useColumnStyles, useDimensionOption } from './hooks';

export const RateListTable = ({
  projectRates,
  projectDimensions,
  formOnChange,
  hasMore,
  loadingMore,
  loadMore,
  errors,
  openDeleteDialog,
  projectSlug,
  addNewEntry,
  setAddNewEntry,
  projectCurrency,
  readOnly,
  firstRowDeletable,
  columnRenderOverrides,
  columnPropOverrides
}) => {
  const columnClasses = useColumnStyles({ readOnly });
  const isPsaPrpTcopEnabled = useHasFeatureFlag({
    featureFlag: 'isPsaPrpTcopEnabled'
  });
  const {
    usersResponse,
    rolesResponse,
    payCodeResponse,
    onInputChange
  } = useDimensionOption(projectSlug);

  const columns = useListColumns({
    projectDimensions,
    formOnChange,
    defaultRate: DEFAULT_RATE,
    classes: columnClasses,
    errors,
    usersResponse,
    rolesResponse,
    payCodeResponse,
    onInputChange,
    readOnly,
    columnRenderOverrides,
    columnPropOverrides
  });

  return (
    <RateListDataTable
      columns={columns}
      records={projectRates}
      hasMore={hasMore}
      loadingMore={loadingMore}
      loadMore={loadMore}
      openDeleteDialog={openDeleteDialog}
      onDeleteGroup={formOnChange.onDeleteGroup}
      projectDimensions={projectDimensions}
      addNewEntry={addNewEntry}
      setAddNewEntry={setAddNewEntry}
      onAddNewEntry={formOnChange.onAddNewEntry}
      projectCurrency={projectCurrency}
      readOnly={readOnly}
      firstRowDeletable={firstRowDeletable}
      isPsaPrpTcopEnabled={isPsaPrpTcopEnabled}
    />
  );
};

RateListTable.propTypes = {
  projectRates: PropTypes.array,
  projectDimensions: PropTypes.array,
  formOnChange: PropTypes.object,
  hasMore: PropTypes.bool,
  loadingMore: PropTypes.bool,
  loadMore: PropTypes.func,
  openDeleteDialog: PropTypes.func,
  errors: PropTypes.object,
  onDeleteGroup: PropTypes.func,
  projectSlug: PropTypes.string,
  addNewEntry: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  setAddNewEntry: PropTypes.func,
  projectCurrency: PropTypes.object,
  readOnly: PropTypes.bool,
  firstRowDeletable: PropTypes.bool,
  columnRenderOverrides: PropTypes.object,
  columnPropOverrides: PropTypes.object
};

export default RateListTable;
